import React from 'react';
import './Form.css';
import Brother from '../Brother/Brother_FeildReport.png';

// const Brotherprint = () => {
const Brotherprint = ({ onClose, labelData }) => {

    const tableStyle = {
        border: '1px solid black',
        width: '100.5%',
        borderCollapse: 'collapse',
    };

    const cellStyle = {
        border: '1px solid black',
        padding: '8px',
        verticalAlign: 'top',
    };

    const headerStyle = {
        border: '1px solid black',
        padding: '8px',
        fontWeight: 'bold',
        textAlign: 'center',
    };

    const headerStyles = {
        // your existing styles
        padding: '5px',
        border: '1px solid black',

        fontWeight: 'bold',
        textAlign: 'center',

    }
    const cellStyles = {
        // your existing styles
        padding: '15px', // adjust padding as needed
        border: '1px solid black',

        verticalAlign: 'top',
    };

    const pendingReasonHeaderStyle = {
        ...headerStyles,
        paddingRight: '10px',
    };

    const pendingReasonCellStyle = {
        ...cellStyles,
        paddingRight: '10px',
    };

    const cellStyleP = {
        BorderBottom: 'none',
        BorderTop: 'none',
        borderLeft: '1px solid black',
        borderRight: '1px solid black',
        padding: '0px',
        //border: '1px solid black',
        width: '100%',
        borderCollapse: 'collapse',
    };

    const boarderstyle = {


        borderRight: '1px solid black',
        height: '100%'
    };

    const cellStyles3 = {
        padding: '3px', // Reduce padding as needed
        border: '1px solid black',
        textAlign: 'left',
        fontFamily: 'Arial'
    };

    const cellStyles4 = {
        padding: '5px', // Reduce padding as needed
        border: '1px solid black',
        textAlign: 'left',
        fontFamily: 'Arial'
    };

    const formatTime = (time) => {
        // Example: '15:43:22.0800000' -> '15:43'
        const timePattern = /^\d{2}:\d{2}(:\d{2}\.\d+)?$/;
        if (timePattern.test(time)) {
            return time.slice(0, 5); // Extracting HH:MM
        }

        // Attempt to parse as Date object if not in expected format
        try {
            const date = new Date(time);
            if (isNaN(date)) throw new Error('Invalid date');
            const hours = date.getHours().toString().padStart(2, '0');
            const minutes = date.getMinutes().toString().padStart(2, '0');
            return `${hours}:${minutes}`;
        } catch (error) {
            console.error('Error formatting time:', error);
            return 'Invalid time';
        }
    };


    return (
        <div>
            {labelData && (
                <>
                    <div style={{ marginTop: '-0.5px' }}>
                        <img src={Brother} alt="Company Logo" style={{ maxHeight: '97px', margin: '0 auto', width: '100%' }} />
                    </div>
                    <div className="form-container">
                        <br />
                        <table style={tableStyle}>
                            <tbody>

                                <tr>
                                    <td colSpan="4" style={{ ...cellStyle, width: '54.3%' }}>
                                        <div className="section-header" style={{ fontWeight: 'bold' }}>Customer Detail</div>
                                        <hr style={{ width: '103%', marginLeft: '-1.5%', color: 'black', fontWeight: 'bolder' }} />
                                        <div className="detail" style={{ fontFamily: 'Arial' }}>
                                            Name : {labelData.BrotherPrint.Customer}
                                            {/* {labelData.BrotherPrint.CustomerAddress} */}
                                        </div>
                                        <div className="detail" style={{ fontFamily: 'Arial' }}>
                                            Address :{labelData.BrotherPrint.Address}
                                        </div>
                                        <br></br>
                                        <br></br>
                                        <div className="detail" style={{ fontFamily: 'Arial' }}>
                                            City & State :<span>{labelData.BrotherPrint.CityandState} </span> / <span style={{ marginLeft: '5px' }}>{labelData.BrotherPrint.State1} </span>
                                        </div>
                                        <br></br>
                                        <hr style={{ width: '189.0%', marginLeft: '-1.5%', color: 'black', fontWeight: 'bold' }} />
                                        <div className="detail" style={{ fontFamily: 'Arial' }}>Phone No (Resi) : {labelData.BrotherPrint.PhoneNumber}</div>
                                        <div className="detail" style={{ fontFamily: 'Arial' }}>E-Mail ID : {labelData.BrotherPrint.Email}</div>
                                        <div className="detail" style={{ fontFamily: 'Arial' }}>Contact person : {labelData.BrotherPrint.ContactPerson}</div>
                                        <div className="detail" style={{ marginLeft: '370px', marginTop: '-30px', fontFamily: 'Arial' }}>Mobile No : {labelData.BrotherPrint.PhoneNumber}</div>
                                    </td>
                                    <tr>
                                        <tr>
                                            <td colSpan="1">
                                                <br></br>
                                                <div className="detail" style={{ marginLeft: '3%', fontFamily: 'Arial' }}>
                                                    Call No      : {labelData.BrotherPrint.CallNo}
                                                </div>
                                                <div className="detail" style={{ marginLeft: '3%', fontFamily: 'Arial' }}>
                                                    Call Date    : {labelData.BrotherPrint.CallDate && new Date(labelData.BrotherPrint.CallDate).toLocaleDateString('en-GB')}
                                                </div>
                                                <div className="detail" style={{ marginLeft: '3%', fontFamily: 'Arial' }}>
                                                    Service Type : {labelData.BrotherPrint.ServiceType}
                                                </div>
                                                <div className="detail" style={{ marginLeft: '3%', fontFamily: 'Arial' }}>
                                                    Call Type    : {labelData.BrotherPrint.Calltype}
                                                </div>
                                                <div className="detail" style={{ marginLeft: '350px', marginTop: '-80px', fontFamily: 'Arial' }}>
                                                    Appointment Date :
                                                    {labelData.BrotherPrint.AppointmentDate && new Date(labelData.BrotherPrint.AppointmentDate).toLocaleDateString('en-GB')}
                                                </div>
                                                <div className="detail" style={{ marginLeft: '350px', fontFamily: 'Arial' }}>
                                                    {/* Appointment Time : {labelData.BrotherPrint.AppointmnentTime} */}
                                                    {/* Appointment Time: {formatTime(labelData.BrotherPrint.AppointmnentTime)} */}
                                                    Appointment Time:
                                                </div>
                                                <div className="detail" style={{ marginLeft: '350px', fontFamily: 'Arial' }}>
                                                    Allocation Date : {labelData.BrotherPrint.AllocatedDate && new Date(labelData.BrotherPrint.AllocatedDate).toLocaleDateString('en-GB')}
                                                </div>
                                                <div className="detail" style={{ marginLeft: '350px', fontFamily: 'Arial' }}>
                                                    {/* Allocation Time :{labelData.BrotherPrint.AllocatedTime} */}
                                                    Allocation Time :
                                                </div>
                                                <hr style={{ width: '186.7%', marginLeft: '-0.5%', color: 'black', fontWeight: 'bold' }} />
                                                <div className="section-header" style={{ marginLeft: '1.5%' }}> Allocated To Engineer <span style={{ maxHeight: '10%' }}>|</span>  {labelData.BrotherPrint.AllocatedToEngineer}</div>

                                                <hr style={{ width: '187.0%', marginLeft: '-0.5%', color: 'black', fontWeight: 'bold' }} />
                                                <div className="section-header" style={{ textAlign: 'center', fontWeight: 'bold' }}>Purchase Detail </div>
                                            </td>


                                        </tr>
                                        <tr>
                                            <td colSpan="1">

                                                <div className="detail" style={{ color: 'black', marginLeft: '1.5%', marginTop: '1.0%', fontFamily: 'arial' }}>  Purchased From  :</div>

                                                <div className="detail" style={{ color: 'black', marginLeft: '1.5%', fontFamily: 'arial' }}> Purchase State & City :</div>

                                                <div className="detail" style={{ color: 'black', marginLeft: '1.5%', fontSize: '14px', fontFamily: 'arial' }}>Customer Invoice No : {labelData.BrotherPrint.Customerinvoiceno}</div>

                                                <div className="detail" style={{ marginLeft: '70%', marginTop: '-40px', fontSize: '14px', fontFamily: 'arial' }}>
                                                    Distributor Name  :
                                                </div>

                                                <div className="detail" style={{ marginLeft: '50%', marginTop: '5%', fontSize: '14px', fontFamily: 'arial' }}>
                                                    Customer Invoice Date:{labelData.BrotherPrint.Customerinvoicedate && new Date(labelData.BrotherPrint.Customerinvoicedate).toLocaleDateString('en-GB')}
                                                </div>

                                            </td>
                                        </tr>
                                    </tr>

                                </tr>

                                <tr>
                                    <td colSpan="4.5" style={cellStyle}>
                                        <div className="section-header" style={{ textAlign: 'center', fontWeight: 'bold', fontFamily: 'Arial' }}>Product Detail</div>
                                        <div className="detail">

                                        </div>
                                    </td>
                                    <td colSpan="1.5" style={cellStyle}>
                                        <div className="section-header" style={{ textAlign: 'center', fontWeight: 'bold', fontFamily: 'Arial' }}>Problem Reported</div>
                                        <div className="detail">

                                        </div>
                                    </td>
                                </tr>

                                <tr>
                                    <td colSpan="6" style={cellStyle}>
                                        <div style={{ display: 'flex', width: '100%' }}>
                                            <div className='boarder' style={{ ...boarderstyle, flex: 1, borderRight: '1px solid black', padding: '5px', maxWidth: '35%' }}>
                                                <div className="detail" style={{ fontFamily: 'Arial' }}>Product Group : {labelData.BrotherPrint.ProductGroup}</div>

                                                <div className="detail" style={{ fontFamily: 'Arial', marginTop: '0.5%' }}>Product Category : {labelData.BrotherPrint.ProductCategory}</div>

                                                <div className="detail" style={{ fontFamily: 'Arial' }}>Model Description : {labelData.BrotherPrint.ModalDescription}</div>

                                                <div className="detail" style={{ fontFamily: 'Arial' }}>Page Count : </div>

                                                <div className="detail" style={{ fontFamily: 'Arial' }}>Warranty Type : {labelData.BrotherPrint.warranty}</div>

                                            </div>
                                            <div style={{ ...boarderstyle, flex: 1, borderRight: '1px solid black', padding: '5px', maxWidth: '35%' }}>
                                                <div className="detail" style={{ fontFamily: 'Arial' }}>Model No : {labelData.BrotherPrint.ModalNo}</div>

                                                <div className="detail" style={{ fontFamily: 'Arial' }}>Unit Serial No : {labelData.BrotherPrint.UnitSerialNo}</div>

                                                <div className="detail" style={{ fontFamily: 'Arial' }}>Installation date :{labelData.BrotherPrint.InstallationDate && new Date(labelData.BrotherPrint.InstallationDate).toLocaleDateString('en-GB')}</div>

                                                <div className="detail" style={{ fontFamily: 'Arial' }}>Distance : {labelData.BrotherPrint.Distance}</div>

                                            </div>
                                            <span style={{ marginLeft: '5px', fontFamily: 'arial', fontSize: '14px' }}> {labelData.BrotherPrint.Reportedprob} </span>
                                        </div>

                                    </td>
                                </tr>

                                <tr>
                                    <td colSpan="7" style={{ cellStyle, width: '1590px', marginLeft: '5%', marginBottom: '5px', marginRight: '4px' }}>
                                        <div className="section-header" style={{ textAlign: 'center', fontWeight: 'bold', fontFamily: 'Arial' }}>Visit Detail</div>
                                        <table style={{ ...cellStyleP, width: '1560.31px', marginLeft: '-1px', marginRight: '0.2px', borderCollapse: 'collapse' }}>
                                            <thead>
                                                <tr>
                                                    <th style={{ ...headerStyles, width: '8%', fontWeight: 'normal', fontFamily: 'Arial', border: '1px solid black', padding: '5px' }}>Visit No</th>
                                                    <th style={{ ...headerStyles, width: '10%', fontWeight: 'normal', fontFamily: 'Arial', border: '1px solid black', padding: '5px' }}>Visit Date</th>
                                                    <th style={{ ...headerStyles, width: '12%', fontWeight: 'normal', fontFamily: 'Arial', border: '1px solid black', padding: '5px' }}>Engineer Name</th>
                                                    <th style={{ ...headerStyles, width: '20%', fontWeight: 'normal', fontFamily: 'Arial', border: '1px solid black', padding: '5px' }}>Engineer Diagnosis</th>
                                                    <th style={{ ...headerStyles, width: '20%', fontWeight: 'normal', fontFamily: 'Arial', border: '1px solid black', padding: '5px' }}>Observation</th>
                                                    <th style={{ ...headerStyles, width: '12%', fontWeight: 'normal', fontFamily: 'Arial', border: '1px solid black', padding: '5px' }}>Action</th>
                                                    <th style={{ ...pendingReasonHeaderStyle, width: '17%', fontWeight: 'normal', fontFamily: 'Arial', border: '1px solid black', padding: '5px' }}>Pending Reason</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td style={{ ...cellStyles3, border: '1px solid black', fontFamily: 'Arial'}}> {labelData.BrotherPrint.VisitNo}</td>
                                                    <td style={{ ...cellStyles3, border: '1px solid black', fontFamily: 'Arial' }}> {labelData.BrotherPrint.VisitDate && new Date(labelData.BrotherPrint.VisitDate).toLocaleDateString('en-GB')}</td>
                                                    <td style={{ ...cellStyles3, border: '1px solid black', fontFamily: 'Arial' }}> {labelData.BrotherPrint.EngineerName}</td>
                                                    <td style={{ ...cellStyles3, border: '1px solid black', fontFamily: 'Arial' }}> {labelData.BrotherPrint.EngineerDiagniosis}</td>
                                                    <td style={{ ...cellStyles3, border: '1px solid black', fontFamily: 'Arial' }}> {labelData.BrotherPrint.Observation}</td>
                                                    <td style={{ ...cellStyles3, border: '1px solid black', fontFamily: 'Arial' }}> {labelData.BrotherPrint.Action}</td>
                                                    <td style={{ ...pendingReasonCellStyle, border: '1px solid black', fontFamily: 'Arial' }}> {labelData.BrotherPrint.PendingReason}</td>
                                                </tr>
                                            </tbody>
                                        </table>

                                        <table style={{ marginLeft: '-1px', width: '1559.5px', marginBottom: '-3px', borderCollapse: 'collapse' }}>
                                            <thead>
                                                <tr>
                                                    <th style={{ ...headerStyle, fontWeight: 'normal', fontFamily: 'Arial', border: '1px solid black', padding: '5px' }}>Part No</th>
                                                    <th style={{ ...headerStyle, fontWeight: 'normal', fontFamily: 'Arial', border: '1px solid black', padding: '5px' }}>Part Name</th>
                                                    <th style={{ ...headerStyle, fontWeight: 'normal', fontFamily: 'Arial', border: '1px solid black', padding: '5px' }}>Quantity</th>
                                                    <th style={{ ...headerStyle, fontWeight: 'normal', fontFamily: 'Arial', border: '1px solid black', padding: '5px' }}>Repair Activity</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {labelData && labelData.BrotherPrint.invoiceItems.map((record, index) => (
                                                    <tr key={index}>
                                                        <td style={{ ...cellStyles4, border: '1px solid black' }}>{record.Code}</td>
                                                        <td style={{ ...cellStyles4, border: '1px solid black' }}>{record.Spare}</td>
                                                        <td style={{ ...cellStyles4, border: '1px solid black' }}>{record.Quantity}</td>
                                                        <td style={{ ...cellStyles4, border: '1px solid black' }}></td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>


                                <div style={{ ...tableStyle, maxHeight: '70px', width: '200%', height: '150px' }}>
                                    <p style={{ fontSize: '14px', marginLeft: '1.8%', fontFamily: 'Arial' }}>Remarks for ASP: <span style={{ fontSize: '14px' }}>{labelData.BrotherPrint.RemarksforASP}</span></p>
                                </div>
                                <div style={{ ...tableStyle, display: 'flex', width: '200%', height: '100px' }}>
                                    <div style={{ flex: 1, borderRight: '1px solid black', padding: '5px', flexBasis: '75%' }}>
                                        <p style={{ fontSize: '14px', marginLeft: '2.0%', fontFamily: 'Arial' }}>Registration Remarks:<span style={{ fontSize: '14px' }}></span>{labelData.BrotherPrint.PendingReason}</p>
                                    </div>
                                    <div style={{ flex: 1, padding: '5px', flexBasis: '25%', }}>
                                        <p style={{ fontSize: '14px', marginLeft: '1.8%', fontFamily: 'Arial' }}>Engineer's Signature:</p>
                                        <p style={{ fontSize: '16px', fontFamily: 'Arial' }}>{labelData.BrotherPrint.EngineerName}</p>
                                    </div>
                                </div>
                                <div style={{ ...tableStyle, display: 'flex', width: '200%', height: '120px' }}>
                                    <div style={{ flexBasis: '75%', borderRight: '1px solid black', padding: '5px' }}>
                                        <span style={{ color: 'black', fontWeight: 'bolder', fontFamily: 'Arial' }}>Terms & Condition</span>
                                        <p style={{ marginTop: '3px', fontFamily: 'Arial' }}>1- If on repair, diagnosed as Liquid Abuse/any internal damage/Tempered, will be treated as chargeable.</p>
                                        <p style={{ marginTop: '0', fontFamily: 'Arial' }}>2- Please collect the product within 15 working days, beyond these the service centre will treat as UNC.</p>
                                        <p style={{ marginTop: '0', fontFamily: 'Arial' }}>3- Warranty, a Sole discretion of BROTHER.</p>
                                    </div>
                                    <div style={{ flexBasis: '25%', padding: '5px', fontFamily: 'Arial' }}>
                                        <p style={{ fontSize: '14px', marginLeft: '1.8%', fontFamily: 'Arial' }}>Customer's Signature :</p>
                                    </div>
                                </div>
                            </tbody>
                        </table>
                    </div>
                </>
            )
            }
        </div >
    );
};

export default Brotherprint;
